import { useAppSelector } from '../../store';
import { useQuery } from '@tanstack/react-query';
import API from 'api';
import { MerchantDto } from 'api/generated';

const getMerchant = async () => {
  const merchant = await API.Merchant.findMerchantByUser();
  if (merchant.data.status === 'SUCCESS') {
    return merchant.data.data as MerchantDto;
  } else {
    return null;
  }
};

const POLL_INTERVAL_MS = 3000;

export const useMerchant = ({ poll = false }: { poll?: boolean } = {}) => {
  const { jwtToken } = useAppSelector((state) => state.user);
  return useQuery({
    queryKey: ['merchant'],
    queryFn: getMerchant,
    refetchOnMount: false,
    refetchOnReconnect: true,
    enabled: !!jwtToken,
    refetchInterval: poll ? POLL_INTERVAL_MS : false,
  });
};
